import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export const fncGetClients = ({commit, dispatch, state, rootState}, payload)  => {
	Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/config/sites', '', rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
			commit('fncGetClients', data.data);
	});
};

export const fncSetup = ({commit, dispatch, state, rootState}, payload)  => {

	Vue.http.get(window.location.protocol + process.env.API_ENDPOINT + 'Pricelist.php?a=getToken', {}, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error has occured', display: true };
			commit('setSnack', snackDetails);
			console.log(error);
		}).then(data => {
		var tokenDetails = { token: data.token, manufacturer_id: payload.setupClient.client_id, default: 1 };
		Vue.http.get(window.location.protocol + process.env.SPINE_ENDPOINT + '/api/v1/pricelists', { params: tokenDetails }, rootState.headerDetails)
			.then(response => {
				return response.json();
			}, error => {
				var snackDetails = { color: 'error', message: 'An error has occured', display: true };
				commit('setSnack', snackDetails);
				console.log(error);
			}).then(dt => {

				var plist_id = 0;
				if( dt[0] != null ) {
					plist_id = dt[0].pl_id;
				}

				var pricelist = 0;
				var params = {
					"show_log" : 1,
					"client_id": payload.setupClient.client_id,
					"site_id" : payload.setupClient.id,
					"pricelist_id": plist_id,
					"account_name": payload.setupClient.client_name,
					"super_user": {
						"name": payload.setupName,
						"surname": payload.setupSurname,
						"email": payload.setupEmail,
						"contactnum" : "",
						"password": payload.setupPassword
					},
					"trading_name": [
						payload.setupClient.client_name
					],
					"project_module": payload.setupProjectModule == true ? 1 : 0
				}

				Vue.http.post(window.location.protocol + process.env.DEV_ENDPOINT + 'api/create', JSON.stringify(params), rootState.headerDetails)
					.then(response => {
						return response.json();
					}, error => {
						console.log(error);
					}).then(d => {
						if( d.status == 'Exists' ) {
							var snackDetails = { color: 'error', message: 'An instance for this client already exists', display: true };
							commit('setSnack', snackDetails);
						} else if( d.status == 'OK' ) {
							var snackDetails = { color: 'success', message: 'The MyOrder instance was created successfully', display: true };
							commit('setSnack', snackDetails);
							commit('hideModal');
						} else {
							var snackDetails = { color: 'error', message: 'An error occurred while trying to setup the MyOrder instance', display: true };
							commit('setSnack', snackDetails);
						}
				});

		});
	});
};

export const fncSaveSurvey = ({ commit, dispatch, state, rootState }, payload) => {

	// var objAuth = JSON.parse(rootState.objAuthorize);
	var params = {
		params: payload.fields
	};

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Report.php?a=save_survey', params, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {
      if( data.calculator != undefined ) {
        var snackDetails = { color: 'succcess', message: 'Calculator loading... please wait...', display: true };
        commit('setSnack', snackDetails);
        setTimeout(function(){
          window.location = data.calculator + '&quoteId=' + data.quoteId;
        }, 2000)
      } else if ( data.success == true ) {
				var snackDetails = { color: 'succcess', message: 'The Survey Form has been submitted successfully', display: true };
				commit('setSnack', snackDetails);

				setTimeout(function(){
          window.location.href = window.location + '&created=true&quoteNo=' + data.quoteNo + '&type=' + payload.fields.surveyType
          location.reload();
        }, 1000)

			} else {
				var snackDetails = { color: 'error', message: 'There has been an error submitting the Survey Form', display: true };
				commit('setSnack', snackDetails);
			}
	});

};

export const fncUpdateSettings = ({commit, dispatch, state, rootState}, payload)  => {
	state.userEditSettings = true;
	var settings_details = {
		manufacturer: payload.settings.userManufacturer,
		user: payload.settings.userID,
		doc_setting: payload.settings.userDocSetting,
		quote_prefix: payload.settings.userQuotePrefix,
		order_prefix: payload.settings.userOrderPrefix,
		manu_user_doc: payload.settings.userManufacturerDoc,
		cust_user_doc: payload.settings.userCustomerDoc,
		spec_user_doc: payload.settings.userSpecificDoc,
		pub_user_doc: payload.settings.userPublicDoc,
		pdformat_fontsize: payload.settings.userPdfFontsize,
		pdformat_orientation: payload.settings.userPageOrientation,
		pdformat_pagenumbers: payload.settings.userPageNumbers,
		pdformat_terms: payload.settings.userStandardTerms,
		collection_delivery_type: payload.settings.collectionDeliveryType,
		collection_label: payload.settings.collectionLabel,
		delivery_label: payload.settings.deliveryLabel,
		terms_txt: payload.settings.userTermsText,
		quote_expiry: payload.settings.userQuoteExpiry,
		default_user_type: payload.settings.default_user_type,
		installation_active: payload.settings.installationActive,
    company_quote: payload.settings.companyQuote,
    department_active: payload.settings.departmentActive,
    branch_active: payload.settings.branchActive,
    department_status_share: payload.settings.departmentStatusShare,
    quote_status_rank_order: payload.settings.quoteStatusRankOrder,
    allowed_file_types: payload.settings.userAllowedFileTypes,
    max_upload_size: payload.settings.maxFileUpload,
    installer_name: payload.settings.installerName,
    doc_show_quote_details: payload.settings.docShowQuoteDetails,
    doc_show_so_quote_details: payload.settings.docShowSoQuoteDetails,
    doc_show_customer_details: payload.settings.docShowCustomerDetails,
    doc_show_delivery_details: payload.settings.docShowDeliveryDetails,
    manufacturer_address: payload.settings.manufacturerAddress,
    is_dhl: payload.settings.isDhl,
    po_template: payload.settings.poTemplate,
    so_template: payload.settings.soTemplate,
    quote_template: payload.settings.quoteTemplate,
    buy_more_link: payload.settings.buyMoreLink,
    terms_link: payload.settings.termsLink,
    customer_can_collect: payload.settings.customerCanCollect,
    products_can_be_delivered: payload.settings.productsCanBeDelivered,
    delivery_options: payload.settings.deliveryOptions,
    show_client_logo_notification: payload.settings.showClientLogoNotification,
    has_stock: payload.settings.hasStock,
    lookup_client_domain: payload.settings.lookupClientDomain,
    lookup_client_id: payload.settings.lookupClientId,
    lookup_client_user: payload.settings.lookupClientUser,
    lookup_client_password: payload.settings.lookupClientPassword,
    lookup_client_secret: payload.settings.lookupClientSecret,
    hide_ecommerce: payload.settings.hideEcommerce,
    hide_trailing_zeros: payload.settings.hideTrailingZeros,
    hide_vendors: payload.settings.hideVendors,
    vat_including: payload.settings.vatIncluding,
	};

	var params = { params: settings_details };
	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=save_system_settings', params, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			console.log(error);
		}).then(data => {

			var objAuth = JSON.parse(rootState.objAuthorize);
			var editDetails = {
				manufacturer: objAuth.manufacturer,
				manu_user_alias: objAuth.manu_user_alias,
				manu_user_clr: objAuth.manu_user_clr,
				customer_user_alias: objAuth.customer_user_alias,
				customer_user_clr: objAuth.customer_user_clr,
				specifier_user_alias: objAuth.specifier_user_alias,
				specifier_user_clr: objAuth.specifier_user_clr,
				public_user_alias: objAuth.public_user_alias,
				public_user_clr: objAuth.public_user_clr,
				quote_expiry: payload.settings.userQuoteExpiry
			};

			Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=save_user_settings', { params: editDetails }, rootState.headerDetails)
				.then(response => {
					return response.json();
				}, error => {
					var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
					commit('setSnack', snackDetails);
				}).then(data => {
					data = JSON.parse(data);
					if (data.hasOwnProperty('msg') && data.msg === 'success') {
						dispatch({
							type: 'updateObjAuth',
							objChanges: settings_details
						});
					} else {
						var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
						commit('setSnack', snackDetails);
					}
				});
		});
};

export const updateObjAuth = ({commit, dispatch, state, rootState}, payload)  => {
	var uniObjAuthorize = JSON.parse(rootState.objAuthorize);
	for(var key in payload.objChanges) {
		if( key != 'user' && key != 'manufacturer' ) {
			switch(key) {
				case 'pdformat_fontsize':
					uniObjAuthorize['pdf_setting_fontsize'] = payload.objChanges[key];
					break;
				case 'pdformat_orientation':
					uniObjAuthorize['pdf_setting_orientation'] = payload.objChanges[key];
					break;
				case 'pdformat_pagenumbers':
					uniObjAuthorize['pdf_setting_pagenumbers'] = payload.objChanges[key];
					break;
				case 'pdformat_terms':
					uniObjAuthorize['pdf_setting_terms'] = payload.objChanges[key];
					break;
				case 'terms_txt':
					uniObjAuthorize['tc_txt'] = payload.objChanges[key];
					break;
        case 'products_can_be_delivered':
          uniObjAuthorize['productsCanBeDelivered'] = payload.objChanges[key];
          break;
				default:
					uniObjAuthorize[key] = payload.objChanges[key];
			}
		}
	}
	commit('setObjAuthorize', uniObjAuthorize);
	state.userEditSettings = false;
	commit('hideModal');
  var objAuth = JSON.parse(rootState.objAuthorize);
  console.log( objAuth );
	var snackDetails = {color: 'success', message: 'The general settings have been saved', display: true};
	commit('setSnack', snackDetails);
	setTimeout(function(){
		commit('setSnackDisplay', false);
	}, 5000)
};

export const fncRetrieveKams = ({commit, dispatch, state, rootState}, payload)  => {
  var manufacturer = '';
  if( payload != '' ) {
    manufacturer = payload;
  } else {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var manufacturer = objAuth.manufacturer;
  }

	var params = {
		manufacturer: manufacturer,
		role: '',
    hide_details: true
	}

	Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'User.php?a=get_user_by_role', params, rootState.headerDetails)
		.then(response => {
			return response.json();
		}, error => {
			var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
			commit('setSnack', snackDetails);
		}).then(data => {
			commit('fncRetrieveKams', data);
	});

};

export const fncGetAttachmentCategories = ({commit, dispatch, state, rootState}, payload)  => {
  var manufacturer = '';
  if( payload != '' && payload != undefined ) {
    manufacturer = payload;
  } else {
    var objAuth = JSON.parse(rootState.objAuthorize);
    var manufacturer = objAuth.manufacturer;
  }
  var params = {
    manufacturer: manufacturer
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=quote_attachment_categories', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {
      commit('fncSetAttachmentCategory', data);
  });

};

export const fncDeleteAttachmentCategory = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    catId: payload.catId
  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=delete_quote_attachment_categories', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

      if( data == true ) {
        var snackDetails = { color: 'success', message: 'The category has been deleted successfully', display: true };
        commit('setSnack', snackDetails);
        dispatch('fncGetAttachmentCategories');
      } else {
        var snackDetails = { color: 'error', message: 'An error occured while trying to delete the category', display: true };
        commit('setSnack', snackDetails);
      }
  });

};

export const fncAddNewQuoteAttachmentCategory = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    manufacturer: objAuth.manufacturer,
    catName: payload.catName
  }
  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=add_quote_attachment_category', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The category has been added successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch('fncGetAttachmentCategories');
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to add the category', display: true };
      commit('setSnack', snackDetails);
    }
  });

};

export const fncUpdateQuoteAttachmentCategory = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    manufacturer: objAuth.manufacturer,
    catId: payload.catId,
    catName: payload.catName
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=edit_quote_attachment_category', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The category has been updated successfully', display: true };
      commit('setSnack', snackDetails);
      dispatch('fncGetAttachmentCategories');
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to updated the category', display: true };
      commit('setSnack', snackDetails);
    }
  });

};

export const fncCheckManufacturerToken = ({commit, dispatch, state, rootState}, payload)  => {
  //var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    manufacturer: payload.manufacturer,
    token: payload.token
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=check_manufacturer_token', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

      commit( 'fncSetManufacturerToken', data );

  });

};

export const fncUpdateSurveyDocument = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  payload.userid = objAuth.id;
  var params = {
    data: payload
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=editSurvey', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

    if( data == true ) {
      var snackDetails = { color: 'success', message: 'The survey document has been updated successfully', display: true };
      commit('setSnack', snackDetails);
      commit('hideModal');

      setTimeout(function(){
        if( window.location.hash.indexOf('quote-single-content?quote=') != -1 ) {
          this.$router.push({path: '/reports/quote-reports-lite', query: {p: 1}});
          this.$router.go();
        } else {
          location.reload();
        }
      }, 500)
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to updated the survey document', display: true };
      commit('setSnack', snackDetails);
    }
  });

};

export const fncUpdateSurveyDocumentType = ({commit, dispatch, state, rootState}, payload)  => {

  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    quote: payload,
    user: objAuth.id,
    manufacturer: objAuth.manufacturer
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'Quote.php?a=editSurveyType', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the survey type', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

      if( data.flag == true ) {
        var snackDetails = { color: 'success', message: data.message, display: true };
        commit('setSnack', snackDetails);
      } else {
        var snackDetails = { color: 'error', message: data.message, display: true };
        commit('setSnack', snackDetails);
      }

    commit('setConvertLoading', false);

    /*if( data == true ) {
      var snackDetails = { color: 'success', message: 'The survey document has been updated successfully', display: true };
      commit('setSnack', snackDetails);
      commit('hideModal');

      setTimeout(function(){
        location.reload();
      }, 500)
    } else {
      var snackDetails = { color: 'error', message: 'An error occured while trying to updated the survey document', display: true };
      commit('setSnack', snackDetails);
    }*/
  });

};

export const fncPrintTest = ({commit, dispatch, state, rootState}, payload)  => {

  /*
  $documentFormat = array();
        $documentFormat['border'] = array();
        $documentFormat['border']['top'] = '15px';
        $documentFormat['border']['left'] = '15px';
        $documentFormat['border']['right'] = '15px';
        $documentFormat['border']['bottom'] = '15px';
        $documentFormat['footer'] = array();
        //$documentFormat['header'] = array();
        $documentFormat['footer']['contents'] = array();
        //$documentFormat['header']['contents'] = array();
        $footer = '';
        $footer .= '<footer style="position: absolute; bottom: 0;width:100%;">';
        $footer .= '    <div class="footer" style="border-top: 1px solid #f1f1f1; text-align: center">';
        $footer .= '        <div class="page-number" style="font-size: 8px;line-height:10px;">PAGE {{page}} OF {{pages}}</div>';
        $footer .= '        <div class="client-name" style="font-size: 8px;line-height:10px; color: grey">'.strtoupper( $poDetails['client_name'] ).'</div>';
        $footer .= '        </div>';
        $footer .= '</footer>';

        $documentFormat['footer']['contents']['default'] = $footer;
        /*$documentFormat['header']['contents']['default'] = $header;
        $documentFormat['header']['height'] = '15mm';*/

  /*return array(
    'html' => $html,
    'documentFormat' => $documentFormat
);
   */

  var htmlDetails = {
    html: payload
  }

  Vue.http.post(window.location.protocol + process.env.DEV_DOC + 'process', htmlDetails, rootState.headerDetails, { emulateJSON: false })
    .then(response => {
      return response.body;
    }, error => {
      console.log(error);
    }).then(data => {

    var reportDownload = document.createElement('a');
    reportDownload.setAttribute('href', 'data:application/octet-stream;base64,' + data);
    reportDownload.setAttribute('download', 'testfile.pdf');
    reportDownload.click();

  });

};

export const fncGetTemplates = ({commit, dispatch, state, rootState}, payload)  => {
  var objAuth = JSON.parse(rootState.objAuthorize);
  var params = {
    manufacturer: objAuth.manufacturer
  }

  Vue.http.post(window.location.protocol + process.env.API_ENDPOINT + 'System.php?a=get_templates', params, rootState.headerDetails)
    .then(response => {
      return response.json();
    }, error => {
      var snackDetails = { color: 'error', message: 'An error occured while trying to update the user settings', display: true };
      commit('setSnack', snackDetails);
    }).then(data => {

      if( data != false ) {
        commit('fncSetTemplates', data);
      }

  });

};
